// Shared "unlock with subscription" treatment used by every locked premium
// panel (Inventory / Timesheets / Loyalty / Reports). Pure markup + a
// self-initialized delegated click listener - not a View (owns no DOM element
// of its own), same "pure helper" shape as currency.js / escape.js. Card copy
// lives on model.PLAN_GATED_FEATURES so this file stays purely presentational.
//
// One consistent treatment everywhere: real stat tiles stay live where a
// panel already computes them (Inventory/Loyalty/Timesheets), but the deeper
// locked content is always ONE simple generic blurred preview - never
// customized per sub-tab/section. Each view builds that preview from a small
// set of fabricated records (never real data), and blurWrapMarkup() below
// wraps it with the lock card. Deliberately not "realistic per-tab" - kept
// simple everywhere, including Reports' non-Overview content.
import { PLAN_GATED_FEATURES } from './model.js';

const LOCK_SVG = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>`;

// Just the "$19/mo Unlock" card - callers center this over their own blurred
// fake content via blurWrapMarkup().
export const lockOverlayMarkup = function (featureKey) {
  const f = PLAN_GATED_FEATURES[featureKey];
  if (!f) return '';
  return `
    <div class="plan-lock-card">
      <span class="plan-lock-icon" aria-hidden="true">${LOCK_SVG}</span>
      <h3 class="plan-lock-title">Unlock ${f.title}</h3>
      <p class="plan-lock-blurb">${f.blurb}</p>
      <ul class="plan-lock-bullets">
        ${f.bullets.map((b) => `<li>${b}</li>`).join('')}
      </ul>
      <div class="plan-lock-price"><span class="plan-lock-price-amt">$19</span><span class="plan-lock-price-period">/mo</span></div>
      <button type="button" class="btn-primary plan-lock-upgrade-btn" data-upgrade-feature="${featureKey}">Upgrade to Unlock</button>
    </div>`;
};

// Fills whatever container it's placed in with the caller's fake (never real)
// content, blurred and non-interactive, with the lock card centered on top -
// never floats a card over dead whitespace.
export const blurWrapMarkup = function (featureKey, fakeContentHtml) {
  return `
    <div class="plan-blur-wrap">
      <div class="plan-blur-content" aria-hidden="true">${fakeContentHtml}</div>
      <div class="plan-blur-overlay">${lockOverlayMarkup(featureKey)}</div>
    </div>`;
};

let _upgradeHandler = null;

// Controller registers its click handler here at init, mirroring the
// `_addHandlerX(handler)` wiring pattern views use elsewhere.
export const _addHandlerUpgradeClick = function (handler) {
  _upgradeHandler = handler;
};

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-upgrade-feature]');
  if (!btn) return;
  _upgradeHandler?.(btn.dataset.upgradeFeature);
});
